// Valor Web shut to players (Ben, Oct 22 2026): "I do not even want them to see a login screen. Maybe just a Coming Soon
// screen." Shown for every address but a shared report link (/r/<id>) while the Worker's WEB_SIGNIN is "closed".
import { art } from "@/kit/art";
import { Flourish } from "@/kit/icons";
import { Card } from "@/kit/primitives";
import { Shell } from "@/kit/chrome";
import "./signin.css";

export function Closed() {
  return (
    <Shell className="signin pg-col">
      <div className="signin-top">
        <div className="toprule" />
        <div className="wordmark-row">
          <Flourish mirror className="fl" />
          <h1 className="valor">VALOR</h1>
          <Flourish className="fl" />
        </div>
        <div className="tagline">Forge your legend</div>
      </div>
      <Card bare className="signin-hero hero full">
        <div className="art" style={{ ["--art-w" as string]: "100%" }}>
          <img src={art.hero.home} alt="" decoding="async" />
        </div>
        <div className="body">
          <h2>Coming soon</h2>
          <p>Valor in your browser is on its way. Until then, play Valor Reforged in the app.</p>
        </div>
      </Card>
    </Shell>
  );
}
